import { BabyGender, IBabyNotification, IBabySettings } from 'types'
import { formatDate, formatDateToISO } from 'utils'

export const fillMissingTimeFields = (time: {
  hours: string | number
  minutes: string | number
}): {
  hours: string | number
  minutes: string | number
} => {
  const result = { ...time }

  if (result.hours && !result.minutes) {
    result.minutes = '0'
  } else if (result.minutes && !result.hours) {
    result.hours = '0'
  }

  return {
    hours: result.hours || '0',
    minutes: result.minutes || '0',
  }
}

export const serializeBaby = (data: IBabySettings) => ({
  ...data,
  name: data.name || 'Мой малыш',
  gender: data.gender || BabyGender.MALE,
  birthDate: data.birthDate
    ? formatDateToISO(data.birthDate)
    : formatDate(new Date().toISOString(), 'yyyy-MM-dd'),
  feedNotification: fillMissingTimeFields(data.feedNotification),
  sleepNotification: fillMissingTimeFields(data.sleepNotification),
})

export const serializeNotification = (data: IBabyNotification) => {
  const time = fillMissingTimeFields(data.time)

  return {
    ...data,
    time,
  }
}
